export default {
	data() {
		return {
			stepElementPosition: {
				hideOnLeft: 0,
				onView: 1,
				lastVisibleOnRight: 2,
				hideOnRight: 3
			},
			currentIndexActive: 0,
			lastIndexTabVisible: 0,
			stepContainerRect: undefined,
			stepElements: [],
			scrollEvent: undefined
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.calculateStepContainerRect();

			this.stepElements = Array.from(
				this.$refs.stepListRef.querySelectorAll('li')
			);
			this.scrollEvent = window.addEventListener(
				'resize',
				this.calculateStepContainerRect
			);
		});
	},
	beforeDestroy() {
		removeEventListener('resize', this.scrollEvent);
	},
	computed: {
		previousActive() {
			return this.currentIndexActive > 0;
		},
		nextActive() {
			return (
				this.currentIndexActive >= 0 &&
				this.currentIndexActive < this.localSteps.length - 1
			);
		},
		cancelActive() {
			return (
				this.currentIndexActive >= 0 &&
				this.currentIndexActive <= this.localSteps.length - 1
			);
		},
		submitActive() {
			return this.currentIndexActive === this.localSteps.length - 1;
		}
	},
	methods: {
		calculateStepContainerRect() {
			this.stepContainerRect = this.$refs?.stepListRef?.getBoundingClientRect();
		},
		updateCurrentScroll(index) {
			if (index < 0 || index > this.localSteps.length - 1) return;

			this.updateScroll(index);
		},
		updateCurrentIndexActive(index) {
			if (index < 0 || index > this.localSteps.length - 1) return;

			this.localSteps[this.currentIndexActive].active = false;
			this.localSteps[index].active = true;
			this.currentIndexActive = index;

			this.updateScroll(index);
		},
		updateCurrentIndexActiveWithoutScroll(index) {
			if (index < 0 || index > this.localSteps.length - 1) return;

			this.localSteps[this.currentIndexActive].active = false;
			this.localSteps[index].active = true;
			this.currentIndexActive = index;
		},
		previusTabsDimensions(index) {
			const previusTabsElements = this.stepElements.slice(0, index);
			let total = 0;

			previusTabsElements.forEach(element => {
				if (this.variant !== 'vertical') {
					total += element.getBoundingClientRect().width;
				} else {
					total += element.getBoundingClientRect().height;
				}
			});

			return total;
		},
		updateScroll(index) {
			if (
				this.getElementPosition(index) === 0 ||
				this.getElementPosition(index) === 2 ||
				this.getElementPosition(index) === 3
			) {
				const newScrollValue = this.previusTabsDimensions(index);
				if (this.variant !== 'vertical') {
					this.$refs.stepListRef.scrollLeft = newScrollValue;
				} else {
					this.$refs.stepListRef.scrollTop = newScrollValue;
				}
			}
		},
		getElementPosition(index) {
			const stepElementRect = this.stepElements[
				index
			].getBoundingClientRect();

			if (this.variant !== 'vertical') {
				if (stepElementRect.left < this.stepContainerRect.left) {
					return this.stepElementPosition.hideOnLeft;
				}

				if (stepElementRect.right - 2 > this.stepContainerRect.right) {
					return this.stepElementPosition.hideOnRight;
				}

				if (index + 1 < this.stepElements.length) {
					const nextStepElementRect = this.stepElements[
						index + 1
					].getBoundingClientRect();
					if (
						nextStepElementRect.right > this.stepContainerRect.right
					) {
						return this.stepElementPosition.lastVisibleOnRight;
					}
				}

				return this.stepElementPosition.onView;
			} else {
				if (stepElementRect.top < this.stepContainerRect.top) {
					return this.stepElementPosition.hideOnLeft;
				}

				if (
					stepElementRect.bottom - 2 >
					this.stepContainerRect.bottom
				) {
					return this.stepElementPosition.hideOnRight;
				}

				if (index + 1 < this.stepElements.length) {
					const nextStepElementRect = this.stepElements[
						index + 1
					].getBoundingClientRect();
					if (
						nextStepElementRect.bottom >
						this.stepContainerRect.bottom
					) {
						return this.stepElementPosition.lastVisibleOnRight;
					}
				}

				return this.stepElementPosition.onView;
			}
		},
		goToPreviousStep() {
			this.updateCurrentIndexActive(this.currentIndexActive - 1);
		},
		goToNextStep() {
			this.updateCurrentIndexActive(this.currentIndexActive + 1);
		}
	}
};
